import React from "react";

import InvestorSectionHeading from "./InvestorSectionHeading";

export default function InvestorPageHeader({ title, subtitle, actions = null, icon = "dashboard" }) {
  return (
    <header className="investor-panel__hero">
      <InvestorSectionHeading icon={icon} tag="h1" className="investor-panel__hero-title" iconSize="hero">
        {title}
      </InvestorSectionHeading>
      {subtitle ? <p className="muted">{subtitle}</p> : null}
      {actions ? <div className="investor-panel__hero-actions">{actions}</div> : null}
    </header>
  );
}
